<template>
  <CardAction
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <HeaderLargePrimary>
      Take skills survey
    </HeaderLargePrimary>
    <div :style="style.text">
      Your workspace admin has requested you to take "{{ surveyName }}".
    </div>
    <div :style="style.buttonContainer">
      <ButtonPrimary
        :disabled="surveys.length === 0"
        @click="goToSurveyPage"
      >
        Take survey
      </ButtonPrimary>
    </div>
  </CardAction>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import CardAction from '@modules/v2/card/card-action'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import { Layout } from '@js/styles'

  export default {
    name: 'survey',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      CardAction,
      HeaderLargePrimary,
    },
    props: {
      surveys: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        style: {
          buttonContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
          },
          card: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '184px',
            padding: Layout.space.md,
            width: '100%',
          },
          text: {},
        },
      };
    },
    computed: {
      survey: function () {
        return this.surveys.length > 0 ? this.surveys[0] : null;
      },
      surveyName: function () {
        return this.survey !== null ? this.survey.name : '';
      },
    },
    methods: {
      goToSurveyPage: function () {
        this.$router.push({
          name: 'survey',
          params: {
            surveyCode: this.survey.code,
          },
        });
      },
    },
  };
</script>
